import { createContext } from 'react';

const Store = createContext({
  record: [],
  mediaState: 'stopped', // stopped, recording, playback
  distance: '',
  inviteModal: 'closed'
})

export default Store;